import Cookies from 'js-cookie'

const TokenKey = 'token-Key'
const MenuList = 'Menu-List'
    // const Menorize = 'Menorize'

export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}

//菜单tab缓存
export function getMenulist() {
    return Cookies.get(MenuList)
}

export function setMenulist(menu) {
    return Cookies.set(MenuList, menu)
}

export function removeMenulist() {
    return Cookies.remove(MenuList)
}
// export function getMenorize() {
//   return Cookies.get(Menorize)
// }

// export function setMenorize(MenorizePassword){
//   return Cookies.set(Menorize,MenorizePassword)
// }

// export function removeMenorize(){
//   return Cookies.remove(Menorize)
// }